Number.prototype.fixTo = function (to) {
    var number = this;

    if (number) {
        return (Math.round(Math.round(number * Math.pow(10, to + 1)) / 10) / Math.pow(10, to));
    } else {
        return 0;
    }
};

Number.prototype.toFixedGood = function (to) {
    var number = this;

    if (number) {
        return Number(number).fixTo(to).toFixed(to).replace(".", ",");
    } else {
        return "0,00";
    }
};

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
};

String.prototype.ellipsis = function (chars_number) {
    if (this.length <= chars_number) {
        return this;
    }

    return this.substr(0, chars_number) + '...';
};
